/**
 * index.js
 *
 * Main project entry point. Import all the initial scaffolding files here.
 *
 */

// Project-wide JS
import 'core-js';
import 'regenerator-runtime/runtime';
import '../1-core/core';
import '../3-components/components';
import '../4-sections/sections';

document.addEventListener('DOMContentLoaded', () => {
    const desktopHeader = document.querySelector('.desktop-header');
    const mobileHeader = document.querySelector('.mobile-header');

    function addClassOnScroll() {
        desktopHeader.classList.remove('transparent');
        mobileHeader.classList.remove('transparent');
    }

    function checkPageHeight() {
        const pageHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.offsetHeight,
            document.body.clientHeight,
            document.documentElement.clientHeight
        );
        const windowHeight = window.innerHeight;

        if (pageHeight <= windowHeight) {
            addClassOnScroll();
        } else {
            window.addEventListener('scroll', addClassOnScroll);
        }
    }

    checkPageHeight();
    window.addEventListener('resize', checkPageHeight);

    const copyButtons = document.querySelectorAll('.copy-data');

    copyButtons.forEach(button => {
        button.addEventListener('click', () => {
            const urlToCopy = button.dataset.url;

            if (!navigator.clipboard) {
                const tempInput = document.createElement('input');
                tempInput.value = urlToCopy;
                document.body.appendChild(tempInput);
                tempInput.select();
                document.execCommand('copy');
                document.body.removeChild(tempInput);
                alert('URL copied to clipboard (fallback method)');
                return;
            }

            navigator.clipboard.writeText(urlToCopy).then(
                () => {
                    alert('URL copied to clipboard!');
                },
                err => {
                    console.error('Failed to copy to clipboard:', err);
                }
            );
        });
    });
});
